import * as React from 'react'
import { useRouter } from 'next/router'
import { LocationKey, LocationsKey } from '../../types/location'

export const PRIVACY_POLICY_URL = 'https://she-inc.co.jp/common/policy.html'
export const AGREEMENT_URL = 'https://she-inc.co.jp/common/agreement.html'
export const SHETRIALLESSON_AGREEMENT_URL =
  'https://she-inc.co.jp/common/agreement.html?agreement_type=shetriallesson'

export const ReservationNote = () => {
  const router = useRouter()

  const { locations_key } = router.query as {
    locations_key: LocationsKey
  }

  return (
    <div
      className="text-left text-[10px] text-black mt-16 sm:mt-[52px] tracking-wider"
      id="reservation-note"
    >
      ※「
      <a
        className="text-black underline"
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noreferrer"
        id="privacy-policy-link"
      >
        プライバシーポリシー
      </a>
      」および
      <a
        className="text-black underline"
        href={AGREEMENT_URL}
        target="_blank"
        rel="noreferrer"
        id="sheid-agreement-link"
      >
        利用規約集
      </a>
      の「基本利用規約」および「
      <a
        className="text-black underline"
        href={SHETRIALLESSON_AGREEMENT_URL}
        target="_blank"
        rel="noreferrer"
        id="shetriallesson-agreement-link"
      >
        SHE体験レッスン個別規約
      </a>
      」をご確認頂き、同意いただけた場合のみ申込ボタンをクリックしてください。フォームにご入力いただいた情報は、弊社からのサービスのご案内に利用することがございます。
      <br />
      ※当サービスは女性向け（性自認含む）となります。男性のご参加はできかねますので、ご理解ください。
      <br />
      ※体験レッスンの参加は最大3回までです。無断キャンセルやいたずらとみなされる参加が続いた場合、参加をお断りすることがあります。
      {locations_key === LocationKey.SHE_FUKUOKA && (
        <>
          <br />
          ※お話を伺ったうえで、最適な受講プランのご提案をすることがございます。
        </>
      )}
    </div>
  )
}
